"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const config_1 = require("assets/styles/config");
const GenericInput_1 = __importDefault(require("components/general/inputs/GenericInput"));
const Flex_1 = require("components/Dashboard/Flex");
const MalomoButton_1 = require("components/Dashboard/MalomoButton");
const MalomoText_1 = require("components/Dashboard/MalomoText");
const StyledFeatherIcon_1 = require("components/general/StyledFeatherIcon");
const Spacer_1 = require("components/Dashboard/Spacer");
const TwoWayToggle_1 = __importDefault(require("components/Dashboard/TwoWayToggle"));
const StyledLinkText_1 = require("components/Dashboard/StyledLinkText");
const toggleOff = (checked) => (react_1.default.createElement("span", { style: { color: checked ? config_1.colors.grayText : '' } },
    react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
        react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { bold: !checked, className: 'fe fe-lock' }),
        react_1.default.createElement(MalomoText_1.MalomoText, { bold: !checked, fontSize: config_1.fontSizes.small, uppercaseLabel: true }, "Secret"))));
const toggleOn = (checked) => (react_1.default.createElement("span", { style: { color: checked ? '' : config_1.colors.grayText } },
    react_1.default.createElement(Flex_1.Flex, { alignItemsCenter: true },
        react_1.default.createElement(StyledFeatherIcon_1.StyledFeatherIcon, { bold: checked, className: 'fe fe-unlock' }),
        react_1.default.createElement(MalomoText_1.MalomoText, { bold: checked, fontSize: config_1.fontSizes.small, uppercaseLabel: true }, "Publishable"))));
const CreateKeyForm = ({ onCreate }) => {
    const initialState = { name: '', publishable: false };
    const [form, setForm] = (0, react_1.useState)(initialState);
    function updateKeyName(e) {
        setForm(Object.assign(Object.assign({}, form), { name: e.target.value }));
    }
    function updateKeyVisibility(checked) {
        setForm(Object.assign(Object.assign({}, form), { publishable: checked }));
    }
    function isValid() {
        return !!form.name;
    }
    function submit() {
        onCreate({
            type: form.publishable ? 'publishable' : 'secret',
            name: form.name
        });
        setForm(initialState);
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(GenericInput_1.default, { boldLabel: true, "data-id": 'api-key-input', label: 'Key name', onInputChange: updateKeyName, rightLabel: react_1.default.createElement(StyledLinkText_1.StyledLinkText, { href: 'https://docs.gomalomo.com/authentication', rel: 'noreferrer', target: '_blank' }, "See API Documentation for Assistance"), value: form.name }),
        react_1.default.createElement(Spacer_1.Spacer, { margin: '8px' },
            react_1.default.createElement(TwoWayToggle_1.default, { "data-id": 'key-type-toggle', name: 'key-type', off: toggleOff, on: toggleOn, onChange: updateKeyVisibility, value: form.publishable })),
        react_1.default.createElement(MalomoButton_1.MalomoButton, { "data-id": 'create-key-button', disabled: !isValid(), marginTopLarge: true, onClick: submit },
            "Generate ",
            form.publishable ? 'Publishable' : 'Secret',
            " Key")));
};
CreateKeyForm.propTypes = {
    onCreate: prop_types_1.default.func
};
exports.default = CreateKeyForm;
